
import { TrustAPI } from "@/shared/modules/trust-api";
import { ComplianceForm, PartAFormOverview } from "@/shared/modules/typescript-trustapi-client/models";
import { AppInsights } from "@/trust-atcs-app/appInsights";
import store from "@/trust-atcs-app/store";
import { EventEmitter } from "events";
import {Emit, Inject, Options, Prop, Vue, Watch} from "vue-property-decorator";
import FormatDateTimeMixin from '@/shared/mixins/format-datetime';
import LoadingSpinner from "@/shared/components/loading-spinner/index.vue";

@Options({
  components: {
    LoadingSpinner
  },
  emits: ['update:isSectionLoading', 'setFormDesc'],
  mixins: [FormatDateTimeMixin],
})
export default class FormPartAOverview extends Vue {

  @Inject({ from: 'apiService', default: new TrustAPI() })
  private apiService!: TrustAPI;

  @Prop({default: false})
  private isSectionLoading!: boolean;

  @Watch('loadingContent')
  private sectionLoading() {
    this.$emit('update:isSectionLoading', this.loadingContent);
  }

  private ai = new AppInsights;
  private loadingContent = false;
  private errorLoadingContent = false;

  private overviewContent: PartAFormOverview = null as any;

  created(): void {
    this.loadOverviewContent();
  }

  mounted(): void {
    this.eventCtrl.on('reload-form-a-overview-content', this.loadOverviewContent);
  }

  beforeUnmount(): void {
    this.eventCtrl.removeListener('reload-form-a-overview-content', this.loadOverviewContent);
  }


  private async loadOverviewContent(): Promise<void> {
    try {
      this.loadingContent = true;
      const resp: any = await this.apiService.PartAFormApi?.apiV2PartAFormGetOverviewPost({
        complianceFormId: this.complianceFormA.id,
        updatingKey: this.updatingKey,
      });

      this.overviewContent = resp.data.data as PartAFormOverview;
      this.$emit('setFormDesc', this.$formatDateFullDate(this.overviewContent?.complianceYearEnd));

      store.dispatch('setFormUpdatingkey', this.overviewContent.updatingKey);
    } catch (err) {
      this.eventCtrl.emit('show-snackbar', 'error', 'Error loading content');
      this.errorLoadingContent = true;
    } finally {
      this.loadingContent = false;
    }
  }

  get eventCtrl(): EventEmitter {
    return store.getters.getEventController;
  }

  get complianceFormA(): ComplianceForm {
    return store.getters.getSelectedComplianceFormA;
  }

  get updatingKey(): string {
    return store.getters.getFormUpdatingKey;
  }

}

